import { Box, useMediaQuery } from "@mui/material";
import { LayoutState, MediaQueryMobile, MediaQueryShallow } from "../Layout";
import LogoDesktop from "./LogoDesktop";
import LogoMobile from "./LogoMobile";

export default function Logo() {
   // Init layout parameters
   const layoutState = new LayoutState();
   layoutState.isMobile = useMediaQuery(MediaQueryMobile);

   if (layoutState.isMobile) {
      return <LogoMobile/>;
   }
   else {
      return <LogoDesktop layoutState={layoutState}/>;
   }

}